<template>
  <b-form class="boolean-search" method="POST" @submit.prevent="() => submitInput()">
    <b-row>
      <b-col cols="12" sm="6" md="4" v-for="key in Object.keys(fields)" :key="key">
        <b-form-group :label="fields[key].label" :label-for="`${key}Input`" :description="fields[key].description">

          <b-form-select v-if="fields[key].type === 'ENUM'" :id="`${key}Input`" :disabled="fields[key].disabled" :options="fields[key].options"
            :value="form[key] || null" @input="value => setValue(key, fields[key], value)">
              <template v-slot:first v-if="fields[key].empty"><option :value="null">{{ fields[key].empty }}</option></template>
          </b-form-select>

          <b-form-input v-else :id="`${key}Input`" :placeholder="fields[key].placeholder" :disabled="fields[key].disabled"
            :value="form[key]" @input="value => setValue(key, fields[key], value)"/>

        </b-form-group>
      </b-col>
      <b-col cols="12" class="text-right">
        <b-form-group>
          <b-button size="md" type="submit" :disabled="!changed" variant="primary">Search</b-button>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
export default {
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(this.value)),
    };
  },
  computed: {
    changed() {
      return JSON.stringify(this.value) !== JSON.stringify(this.form);
    },
  },
  methods: {
    submitInput() {
      this.$emit('input', JSON.parse(JSON.stringify(this.form)));
    },
    setValue(key, field, value) {
      if (typeof field.set === 'function') {
        try {
          value = field.set(value);
        } catch (err) {
          console.error(`Error in ${key}.set method`, err);
          value = value ? `${value}`.trim() : null;
        }
      } else {
        value = value ? `${value}`.trim() : null;
      }

      this.form = { ...this.form, [key]: value };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/misc/BooleanSearch.vue